"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Actions = void 0;
exports.HBDialogContent = HBDialogContent;
exports["default"] = exports.VerticalActionSpacer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBModal = _interopRequireDefault(require("../HBModal/HBModal"));
var _HBModal2 = require("../HBModal/HBModal.styles");
var _HBButton = _interopRequireDefault(require("../HBButton/HBButton"));
var _spacing = _interopRequireDefault(require("../../styles/spacing"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _HBBanner = _interopRequireDefault(require("../HBBanner/HBBanner"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _TriangleExclamationMark = _interopRequireDefault(require("@honeybook/icons/dist/icons/TriangleExclamationMark42"));
var _InfoCircle = _interopRequireDefault(require("@honeybook/icons/dist/icons/InfoCircle42"));
var _CheckCircle = _interopRequireDefault(require("@honeybook/icons/dist/icons/CheckCircle42"));
var _framerMotion = require("framer-motion");
var _excluded = ["customButton", "size", "scope"],
  _excluded2 = ["actions", "title", "description", "icon", "maxWidth", "titleMargin", "actionsDirection", "linkText", "linkAction", "inlineBanner", "testId", "type", "theme"];
var DIALOG_TYPE_PROPS = {
  error: {
    icon: /*#__PURE__*/_react["default"].createElement(_TriangleExclamationMark["default"], {
      color: _colors["default"].red50
    })
  },
  info: {
    icon: /*#__PURE__*/_react["default"].createElement(_InfoCircle["default"], {
      color: _colors["default"].blue20
    })
  },
  success: {
    icon: /*#__PURE__*/_react["default"].createElement(_CheckCircle["default"], {
      color: _colors["default"].green50
    })
  },
  warning: {
    icon: /*#__PURE__*/_react["default"].createElement(_TriangleExclamationMark["default"], {
      color: _colors["default"].red50
    })
  }
};
var Container = (0, _styledComponents["default"])(_framerMotion.motion.div).withConfig({
  displayName: "HBDialog__Container",
  componentId: "sc-o0i0zh-0"
})(["text-align:center;"]);
var Title = (0, _styledComponents["default"])(_HBText["default"]).withConfig({
  displayName: "HBDialog__Title",
  componentId: "sc-o0i0zh-1"
})(["margin:", ";"], function (props) {
  return props.titleMargin;
});
var ActionLink = (0, _styledComponents["default"])(_HBText["default"]).withConfig({
  displayName: "HBDialog__ActionLink",
  componentId: "sc-o0i0zh-2"
})(["margin-top:10px;display:flex;justify-content:center;cursor:pointer;text-decoration:underline;"]);
var Description = (0, _styledComponents["default"])(_HBText["default"]).withConfig({
  displayName: "HBDialog__Description",
  componentId: "sc-o0i0zh-3"
})(["margin-top:10px;white-space:pre-line;"]);
var StyledActionButton = (0, _styledComponents["default"])(_HBButton["default"]).withConfig({
  displayName: "HBDialog__StyledActionButton",
  componentId: "sc-o0i0zh-4"
})(["width:auto;"]);
var BannerContent = _styledComponents["default"].div.withConfig({
  displayName: "HBDialog__BannerContent",
  componentId: "sc-o0i0zh-5"
})(["font-size:12px;justify-content:flex-start;"]);
var Actions = exports.Actions = _styledComponents["default"].div.withConfig({
  displayName: "HBDialog__Actions",
  componentId: "sc-o0i0zh-6"
})(["display:inline-flex;justify-content:center;flex-direction:", ";margin-top:", ";", "{width:", ";}"], function (props) {
  return props.actionsDirection === 'vertical' ? 'column' : 'row';
}, _spacing["default"][24], StyledActionButton, function (props) {
  return props.actionsDirection === 'vertical' ? '100%' : 'auto';
});
var VerticalActionSpacer = exports.VerticalActionSpacer = _styledComponents["default"].div.withConfig({
  displayName: "HBDialog__VerticalActionSpacer",
  componentId: "sc-o0i0zh-7"
})(["margin-top:12px;"]);
var StyledHBModal = (0, _styledComponents["default"])(_HBModal["default"]).withConfig({
  displayName: "HBDialog__StyledHBModal",
  componentId: "sc-o0i0zh-8"
})(["", "{padding:24px;}"], _HBModal2.Body);
function DynamicActionSpacer(_ref) {
  var actionsDirection = _ref.actionsDirection,
    children = _ref.children;
  return actionsDirection === 'vertical' ? /*#__PURE__*/_react["default"].createElement(VerticalActionSpacer, null, children) : /*#__PURE__*/_react["default"].createElement(_HBModal2.ActionSpacer, null, children);
}
function ActionButton(_ref2) {
  var action = _ref2.action,
    actionsDirection = _ref2.actionsDirection;
  var customButton = action.customButton,
    _action$size = action.size,
    size = _action$size === void 0 ? 'sm' : _action$size,
    _action$scope = action.scope,
    scope = _action$scope === void 0 ? 'system' : _action$scope,
    actionProps = (0, _objectWithoutProperties2["default"])(action, _excluded);
  var ButtonComponent = customButton || StyledActionButton;
  var buttonTheme = customButton ? 'custom' : action.theme;
  return /*#__PURE__*/_react["default"].createElement(DynamicActionSpacer, {
    actionsDirection: actionsDirection
  }, /*#__PURE__*/_react["default"].createElement(ButtonComponent, (0, _extends2["default"])({
    size: size,
    scope: scope,
    buttonTheme: buttonTheme,
    testId: action.testIdName ? "hb-dialog-".concat(action.testIdName, "--button") : undefined,
    testIdType: "hb-dialog-action--button"
  }, actionProps), action.text));
}
var HBDialogInlineBanner = function HBDialogInlineBanner(_ref3) {
  var bannerCustomTheme = _ref3.bannerCustomTheme,
    text = _ref3.text,
    margin = _ref3.margin;
  return /*#__PURE__*/_react["default"].createElement(_HBBanner["default"], {
    customTheme: bannerCustomTheme,
    margin: margin
  }, /*#__PURE__*/_react["default"].createElement(BannerContent, null, text));
};
function getIcon(type, icon) {
  var _DIALOG_TYPE_PROPS$ty;
  return icon || ((_DIALOG_TYPE_PROPS$ty = DIALOG_TYPE_PROPS[type]) === null || _DIALOG_TYPE_PROPS$ty === void 0 ? void 0 : _DIALOG_TYPE_PROPS$ty.icon);
}
var HBDialog = function HBDialog(_ref4) {
  var actions = _ref4.actions,
    title = _ref4.title,
    description = _ref4.description,
    icon = _ref4.icon,
    _ref4$maxWidth = _ref4.maxWidth,
    maxWidth = _ref4$maxWidth === void 0 ? '380px' : _ref4$maxWidth,
    _ref4$titleMargin = _ref4.titleMargin,
    titleMargin = _ref4$titleMargin === void 0 ? "".concat(_spacing["default"][16], " 0px 0px 0px") : _ref4$titleMargin,
    _ref4$actionsDirectio = _ref4.actionsDirection,
    actionsDirection = _ref4$actionsDirectio === void 0 ? 'horizontal' : _ref4$actionsDirectio,
    linkText = _ref4.linkText,
    linkAction = _ref4.linkAction,
    inlineBanner = _ref4.inlineBanner,
    testId = _ref4.testId,
    type = _ref4.type,
    theme = _ref4.theme,
    modalProps = (0, _objectWithoutProperties2["default"])(_ref4, _excluded2);
  var isAiTheme = theme === 'ai';
  return /*#__PURE__*/_react["default"].createElement(StyledHBModal, (0, _extends2["default"])({
    maxWidth: maxWidth
  }, isAiTheme ? {
    theme: 'ai'
  } : {}, modalProps), /*#__PURE__*/_react["default"].createElement(HBDialogContent, {
    testId: testId,
    inlineBanner: inlineBanner,
    type: type,
    icon: icon,
    titleMargin: titleMargin,
    title: title,
    description: description,
    linkText: linkText,
    linkAction: linkAction,
    actions: actions,
    actionsDirection: actionsDirection,
    isAiTheme: isAiTheme
  }));
};
var _default = exports["default"] = HBDialog;
function HBDialogContent(_ref5) {
  var testId = _ref5.testId,
    inlineBanner = _ref5.inlineBanner,
    type = _ref5.type,
    icon = _ref5.icon,
    titleMargin = _ref5.titleMargin,
    title = _ref5.title,
    description = _ref5.description,
    linkText = _ref5.linkText,
    linkAction = _ref5.linkAction,
    actions = _ref5.actions,
    actionsDirection = _ref5.actionsDirection,
    animation = _ref5.animation,
    isAiTheme = _ref5.isAiTheme;
  return /*#__PURE__*/_react["default"].createElement(Container, (0, _extends2["default"])({
    "data-testid": testId
  }, animation), inlineBanner && (inlineBanner === null || inlineBanner === void 0 ? void 0 : inlineBanner.position) !== 'bottom' && /*#__PURE__*/_react["default"].createElement(HBDialogInlineBanner, {
    bannerCustomTheme: inlineBanner.bannerCustomTheme,
    text: inlineBanner.text,
    margin: "0 0 14px"
  }), !isAiTheme && getIcon(type, icon), /*#__PURE__*/_react["default"].createElement(Title, {
    tag: "div",
    type: "Title2DarkPrimary",
    titleMargin: isAiTheme ? '0' : titleMargin
  }, title), description && /*#__PURE__*/_react["default"].createElement(Description, {
    tag: "div",
    type: "Body6DarkPrimary"
  }, description), inlineBanner && (inlineBanner === null || inlineBanner === void 0 ? void 0 : inlineBanner.position) === 'bottom' && /*#__PURE__*/_react["default"].createElement(HBDialogInlineBanner, {
    bannerCustomTheme: inlineBanner.bannerCustomTheme,
    text: inlineBanner.text
  }), linkText && linkAction && /*#__PURE__*/_react["default"].createElement(ActionLink, {
    type: "body14",
    onClick: linkAction
  }, linkText), actions && /*#__PURE__*/_react["default"].createElement(Actions, {
    actionsDirection: actionsDirection
  }, actions.map(function (action, index) {
    return /*#__PURE__*/_react["default"].createElement(ActionButton, {
      key: index,
      action: action,
      actionsDirection: actionsDirection
    });
  })));
}
//# sourceMappingURL=HBDialog.js.map